import { render, staticRenderFns } from "./SelectBenefits.vue?vue&type=template&id=5fba7ed6&"
import script from "./SelectBenefits.vue?vue&type=script&lang=js&"
export * from "./SelectBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports